// extracted by mini-css-extract-plugin
export default {"message":"Message_message__5urKX","owner":"Message_owner__quvoj","messageContent":"Message_messageContent__IB-0g","messageInfo":"Message_messageInfo__KCDLu"};